export default __webpack_public_path__ + "static/media/barclays.a1e3f315.svg";